module.exports = {
    nowDownload: 'Download Now',  
    copyRight:'Copyright © Getech Technology Co., Ltd. 2018-2020 all rights reserved',
    androidDown:'Download Android',
    iosDown:'Download IOS',
    identityVerification:'Identity verification', 
    onlyTCL:'Only TCL users are allowed to use it. Please verify your identity and download it',
    oaPlaceholder:'Please enter OA account / email account',
    iosLogin:'Sign in',
    pwdPlaceholder:'Password',
}